import { useVersionStore } from "./version.store";

export const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

async function fetchDeployedVersion(): Promise<string | undefined> {
	try {
		const response = await fetch("/version.json", { cache: "no-store" });
		if (!response.ok) {
			return undefined;
		}
		const body: unknown = await response.json();
		if (typeof body !== "object" || body === null) {
			return undefined;
		}
		const version = (body as { version?: unknown }).version;
		return typeof version === "string" ? version : undefined;
	} catch {
		// Fail open: a flaky network or a proxy that doesn't serve version.json
		// yet must never tell agents the app is outdated.
		return undefined;
	}
}

export async function checkForNewVersion(
	currentVersion: string
): Promise<void> {
	const deployedVersion = await fetchDeployedVersion();
	if (deployedVersion !== undefined && deployedVersion !== currentVersion) {
		useVersionStore.getState().markNewVersionAvailable();
	}
}

export function startVersionCheck(
	currentVersion: string = __APP_VERSION__
): void {
	if (currentVersion === "dev") {
		return;
	}

	const runCheck = () => void checkForNewVersion(currentVersion);
	const intervalId = setInterval(runCheck, VERSION_POLL_INTERVAL_MS);
	window.addEventListener("focus", runCheck);

	// Once stale there is no way back to fresh without a reload — stop polling.
	const unsubscribe = useVersionStore.subscribe((state) => {
		if (state.newVersionAvailable) {
			clearInterval(intervalId);
			window.removeEventListener("focus", runCheck);
			unsubscribe();
		}
	});
}
